import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError} from 'rxjs';
import { environment } from '../../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class APIService {

  constructor(private readonly http: HttpClient,) { }

  get domainUrl(){
     return domain()+this.version  
  }
    version = '/api/v1'  
    routes = {
      searchUsers : '/sst_user/search-users',
      userDetails: '/sst_user/user-details',
      searchCompany: '/sst_user/company-names',
      searchRole: '/sst_user/user-roles',
      searchCostCenter: '/sst_user/cost-center',
      searchSubSubFn: '/sst_user/sub-sub-function',
      postSSTJsx: '/jrx_user/user',
      mdaReportTimestamp : '/mda-sys-reports/mda-sys-reports-timestamp',
      downloadMDAReport : '/mda-sys-reports/mda-sys-reports-download',
      searchSupervisor : '/bulk-upload-supervisors/search-supervisors',
      searchBulkCC: '/bulk-upload-users/search-costcenter',
      getBulkUser: '/bulk-upload-users/get-bulk-users-by-sv-and-cc',
      postBulkUser: '/bulk-upload-users/post-bulk-users-data',
      getAllKeys:'/mcp/get-all-distribution-key-data',
      getCurrentPeriod:'/mcp/get-current-period',
      getKeyById:'/mcp/get-distribution-key-data',
      getKeyMatricesById: '/mcp/get-key-matrices-data',
      deleteKeyById: '/mcp/delete-distribution-key-data',
      postDistributionKey: '/mcp-users/post-distribution-data',
      getActivity: '/mcp/get-activities-data',
      validateActivity: '/mcp/get-validate-activity',
      getAcctPeriod: '/acct_period/acct_period_table',
      updateAcctPeriod: '/acct_period/change_closing_date',
      postAcctPeriod: '/acct_period/post-accounting-period-data',
    }

  searchByEmail(data: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.searchUsers}?${data}`, httpOptions)
      .pipe(
        catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }
  getUserDetails(data: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.userDetails}?${data}`, httpOptions)
      .pipe(
        catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }

  postSSTJsx(data: any){
    return this.http.post<any[]>(this.domainUrl+this.routes.postSSTJsx,data, httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  getCompany(data: string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.searchCompany}?search=${data}`, httpOptions)
      .pipe(
         catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }

  getSubSubFunction(data: string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.searchSubSubFn}?search=${data}`, httpOptions)
      .pipe(
         catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }

  getCostCenter(data:string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.searchCostCenter}?search=${data}`, httpOptions)
      .pipe(
         catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }

  getRoles(data: string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.searchRole}?search=${data}`, httpOptions)
      .pipe(
         catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }

  searchSupervisor(data: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.searchSupervisor}?${data}`, httpOptions)
      .pipe(
         catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }

  searchBulkCC(data:string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.searchBulkCC}?costcenter=${data}`, httpOptions)
      .pipe(
         catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }
  getBulkUserbySVandCC(data:any){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.getBulkUser}?${data}`, httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  postBulkUser(data: any){
    return this.http.post<any[]>(this.domainUrl+this.routes.postBulkUser,data, httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }
  getReportsDetails(){
    return this.http.get<any[]>(this.domainUrl+this.routes.mdaReportTimestamp, httpOptions)
      .pipe(
         catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
      ));
  }

  downloadReport(data: string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.downloadMDAReport}?report_name=${data}`, { ...httpOptions,responseType: 'blob' as 'json'})
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  getAllKeys(){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.getAllKeys}`,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  getCurrentPeriod(){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.getCurrentPeriod}`,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  getKeyById(id:string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.getKeyById}?dk_id=${id}`,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  getKeyMatricesById(id:string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.getKeyMatricesById}?dk_id=${id}`,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  deleteKeyById(id:string){
     return this.http.delete<any[]>(`${this.domainUrl}${this.routes.deleteKeyById}?dk_id=${id}`,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  postDistributionKey(data: any){
    return this.http.post<any[]>(this.domainUrl+this.routes.postDistributionKey,data, httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  getActivity(){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.getActivity}`,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }
  
  validateActivity(name:string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.validateActivity}?activity_name=${name}`,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }

  getAcctPeriod(year:string){
    return this.http.get<any[]>(`${this.domainUrl}${this.routes.getAcctPeriod}?year=${year}`,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }
  
  updateAcctPeriod(data:string){
    return this.http.post<any[]>(`${this.domainUrl}${this.routes.updateAcctPeriod}`,data,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }
  
  postAcctPeriod(data:any){
    return this.http.post<any[]>(`${this.domainUrl}${this.routes.postAcctPeriod}`,data,httpOptions)
    .pipe(
       catchError((error: HttpErrorResponse)=>{
          return throwError(() => (error));
        }
    ));
  }
}

export function domain(){
    if('dev' == environment.ENV){
      return 'https://api.sst-dev.time-tracking.int.bayer.com'
    }else if('qa' == environment.ENV){
      return 'https://api.sst-test.time-tracking.int.bayer.com'  
    }else if('prod' == environment.ENV){
      return 'https://api.sst.time-tracking.int.bayer.com'
    }else{
      return ''
    }
}